import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { FREE_OF_CHARGE_CATEGORY_PATH } from '../../../../config/paths';

const FreeOfChargeCategoryToolbar = ({ freeOfChargeCategoryId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${FREE_OF_CHARGE_CATEGORY_PATH}/${freeOfChargeCategoryId}/edit`}
      />{' '}
    </div>
  </ButtonToolbar>
);

FreeOfChargeCategoryToolbar.propTypes = {
  freeOfChargeCategoryId: PropTypes.number.isRequired,
};

export default FreeOfChargeCategoryToolbar;
